import { render, staticRenderFns } from "./department.vue?vue&type=template&id=59e168ab&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=59e168ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e168ab",
  null
  
)

export default component.exports